import { GpsType } from '../../../../../../global/components/layout/layout-models';
import { ProgressItem } from '../../../../../../global/components/navigation/generic-stepper';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { ArcRoutes } from '../../../../constants/routes';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { NewHireEnrollmentRoutes } from '../../../new-hire-enrollment/models/new-hire-routes';
import { BenefitEnrollmentStep } from '../../../new-hire-enrollment/models/pension-enrollment-models';
import { ParticipantEnrollmentSettings } from '../../models/epi-props';

export function getBenefitEnrollmentSteps() {
	return [BenefitEnrollmentStep.PERSONAL_INFORMATION, BenefitEnrollmentStep.RELATIONSHIP, BenefitEnrollmentStep.COVERAGE, BenefitEnrollmentStep.REVIEW];
}

export function getBenefitEnrollmentStepItems(settings: NewHireProps) {
	const progressItem: ProgressItem[] = [];
	progressItem.push(
		{
			stepName: settings?.personInfoStepName,
			linkUrl: AccountInfoRoutes.PersonalInfoSegment,
			step: BenefitEnrollmentStep.PERSONAL_INFORMATION,
		},
	);
	progressItem.push(
		{
			stepName: settings?.relationshipStepName,
			linkUrl: AccountInfoRoutes.RelationshipsSegment,
			step: BenefitEnrollmentStep.RELATIONSHIP,
		},
	);
	progressItem.push(
		{
			stepName: settings?.offeredCoverageStepName,
			linkUrl: NewHireEnrollmentRoutes.Coverage,
			step: BenefitEnrollmentStep.COVERAGE,
		},
	);
	progressItem.push(
		{
			stepName: settings?.reviewStepName,
			linkUrl: NewHireEnrollmentRoutes.Coverage,
			step: BenefitEnrollmentStep.REVIEW,
		},
	);

	return progressItem;
}

export function GetCustomCoverageModel(settings: ParticipantEnrollmentSettings) {
	return {
		pageTitle: settings?.participantCoveragePageTitle,
		pageDescription: settings?.participantCoveragePageDescription,
		reviewTitle: settings?.coverageReviewPageTitle,
		reviewDescription: settings?.coverageReviewPageDescription,
		gps: GpsType.NEW_PARTICIPANT_COVERAGE,
		reviewGps: GpsType.NEW_PARTICIPANT_COVERAGE_REVIEW,
		confirmationRoute: `${ArcRoutes.ArcRoot}${ArcRoutes.ParticipantEnrollment}${NewHireEnrollmentRoutes.Confirmation}`,
		participantSelectionDescription: settings?.participantSelectionDescription,
	};
}